import React, { useEffect } from 'react';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToast, IonToolbar } from '@ionic/react';
//import ExploreContainer from '../../components/ExploreContainer';
import { arrowBack } from 'ionicons/icons';
import { useHistory, useParams } from 'react-router';
import { observer } from 'mobx-react';
import WarehouseRequestDetail from './WarehouseDetail';
import authStore from '../../store/auth';
import approvalStore from '../../store/approval';

interface Params {
    id: string;
}

const DetailApproval: React.FC = observer(() => {
    const { id } = useParams<Params>();
    const history = useHistory();

    const handleBack = () => {
        history.goBack();
    };

    useEffect(() => {
        authStore.checkAuth();
    }, []);

    const detailData = {
        id: "1",
        type: "Cancel Package",
        requester: "Rizky - Gudang A",
        date: "2025-10-08 09:12",
        reason: "Paket double scan",
        status: "pending" as const,
    };

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            {/* <IonBackButton defaultHref="#" /> */}
                            <IonButton onClick={handleBack} style={{ marginRight: -15 }}>
                                <IonIcon slot="icon-only" icon={arrowBack} color="light"></IonIcon>
                            </IonButton>
                        </IonButtons>
                        <IonTitle>Detail Request</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding" style={{ '--background': '#f8f9fa' }}>
                    <WarehouseRequestDetail
                        data={approvalStore.selected_approval_data ?? null}
                    />
                </IonContent>

                <IonToast
                    isOpen={approvalStore.success_alert_toggle}
                    message="Pengajuan Sudah Diproses!"
                    onDidDismiss={() => approvalStore.setSuccessAlertToggle(false)}
                    duration={3000}
                    position='top'
                    color='success'
                ></IonToast>
            </IonContent>
        </IonPage>
    );
});

export default DetailApproval;
